module.exports = new __parcel__URL__("beetlejuice-robert-goulet.c5587b1a.gif").toString();